import React, { useState, useEffect, useMemo, useRef } from 'react';
import { lockedClose } from "../../../utils/lockedDialog";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, Button,
  TextField, Grid, FormControl, Box, InputLabel, FormHelperText, Select, MenuItem, DialogActions, Typography,
} from '@mui/material';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { PtPackageDropdown, PtTrainerDropdown, TrainerPaymentcHANGE, PtPackageDropdownvalueCHANGE, PtTrainerSlotTimes } from "../../Apihelper/MemberDashboard.js";
import {
  getSessionTimeBoundsForPickers,
  hasTrainerEveningSlot,
  hasTrainerMorningSlot,
  rawEveningSlotPresent,
  isPtEndTimeWithinSessionSlot,
  isPtStartTimeWithinSessionSlot,
  trainerSlotAllowedStartSummaryForSession,
} from "../../../utils/trainerSlotTime";
import dayjs from "dayjs";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AppToast from '../../../components/Toast/AppToast';
import { useTheme as useAppTheme } from '../../../contexts/ThemeContext';
import PayButton, { PaymentOverlay } from "../../../components/PayButton/PayButton";
import { limitAmount } from "../../../utils/amounts";

// packageData.start_date comes from the backend formatted as "DD-MM-YYYY".
const formatDMYToYMD = (date) => {
  if (!date) return dayjs().format('YYYY-MM-DD');
  const [day, month, year] = date.split('-');
  return `${year}-${month}-${day}`;
};

const ChangePackagePt = ({ open, onClose, packageData, member_id, fetchData }) => {
  const { colors: appColors } = useAppTheme();
  const [FormData, setFormData] = useState({
    member_id: "",
    package: "",
    packagevalue: "",
    totalpaybleamount: "",
    discount: "",
    payableamount: "",
    modeofpayment: "",
    payingamount: "",
    activationdate: null,
    dateofpayment: null,
    trainer: "",
    slot: "",
    startTime: null,
    endTime: null,
  });
  const [renwalloading, setRenwalLoading] = useState(false);
  const submittingRef = useRef(false);
  const [Dropdowndata, setDropdowndata] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [packageamount, setPackageamount] = useState("");
  const [Dropdowndatatrainer, setDropdowndatatrainer] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [confirmChangeOpen, setConfirmChangeOpen] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [ptTrainerSlotInfo, setPtTrainerSlotInfo] = useState(null);
  const [ptTrainerSlotLoading, setPtTrainerSlotLoading] = useState(false);

  const ptTimeBounds = useMemo(() => {
    if (!ptTrainerSlotInfo || !FormData.ptSession) return null;
    return getSessionTimeBoundsForPickers(ptTrainerSlotInfo, FormData.ptSession);
  }, [ptTrainerSlotInfo, FormData.ptSession]);

  const ptEndPickerMinTime = useMemo(() => {
    if (!ptTimeBounds) return null;
    const { slotStart } = ptTimeBounds;
    if (FormData.startTime) {
      const st = dayjs(FormData.startTime);
      if (st.isValid() && st.isAfter(slotStart)) return st;
    }
    return slotStart;
  }, [ptTimeBounds, FormData.startTime]);
  const generateHelperText = () => {
    return FormData.totalpaybleamount > packageamount
      ? "Total payable amount cannot exceed the package value"
      : "";
  };
  useEffect(() => {
    fetchDropdowndata();
    fetchDropdowndatatrainer();
    console.log("Package Data:", packageData);
  }, []);

  // Default Date of Payment + Activation Date to today whenever modal opens (DD/MM/YYYY in UI)
  useEffect(() => {
    if (open) {
      setFormData((prev) => ({
        ...prev,
        dateofpayment: dayjs(),
        activationdate: dayjs(),
      }));
      setSubmitted(false);
      setPtTrainerSlotInfo(null);
      setPtTrainerSlotLoading(false);
    }
  }, [open]);

  // Fetch trainer slot times when trainer selection changes
  useEffect(() => {
    if (!FormData.trainer) {
      setPtTrainerSlotInfo(null);
      setPtTrainerSlotLoading(false);
      return undefined;
    }
    let cancelled = false;
    setPtTrainerSlotLoading(true);
    setPtTrainerSlotInfo(null);
    (async () => {
      try {
        const { token } = JSON.parse(localStorage.getItem("userdata") || "{}");
        const res = await PtTrainerSlotTimes(token, FormData.trainer);
        if (cancelled) return;
        if (res.code === "200" || res.code === 200) {
          setPtTrainerSlotInfo(res.data ?? null);
        } else {
          setPtTrainerSlotInfo(null);
        }
      } catch (e) {
        if (!cancelled) setPtTrainerSlotInfo(null);
      } finally {
        if (!cancelled) setPtTrainerSlotLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [FormData.trainer]);
  const fetchDropdowndata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PtTrainerDropdown(userToken, userId);
        
      if (res.code == "200") {
        setDropdowndatatrainer(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  const fetchDropdowndatatrainer = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PtPackageDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdowndata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };

  const handleToastClose = () => setOpenToast(false);

  const handlepayblevalueChange = async (e) => {
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdowndata.find((row) => row.id === selectedPackageId);
    // The backend always computes the new PT package's end_date from the
    // member's CURRENT PT package start_date + the new package's duration —
    // it does not use whatever is picked in the Activation Date field.
    const computedEndDate = selectedPackage?.duration
      ? dayjs(formatDMYToYMD(packageData?.start_date)).add(Number(selectedPackage.duration), "day").format("YYYY-MM-DD")
      : "";
    setFormData({ ...FormData, package: selectedPackageId, end_date: computedEndDate });

    try {
      const userData = JSON.parse(localStorage.getItem("userdata"));
      const userToken = userData.token;
      const Userid = userData.id;
      const res = await PtPackageDropdownvalueCHANGE(userToken,Userid, selectedPackageId,member_id);

      if (res.code == "200") {
        const packageAmount = res.data.package_amount;
        setFormData((prevState) => ({ ...prevState, packagevalue: packageAmount }));
        setFormData((prevState) => ({ ...prevState, totalpaybleamount: packageAmount }));
        setPackageamount(packageAmount);
      } else {
        handleSnackbarOpen(res.message, 'error');
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      handleSnackbarOpen("Failed to fetch package value.", "error");
    }
  };

  const handleTotalPayableAmountChange = (e) => {
    const enteredValue = e.target.value;
    const totalPayableAmount = enteredValue > packageamount ? packageamount : enteredValue;
    setFormData({ ...FormData, totalpaybleamount: totalPayableAmount });
  };

  const handleDiscountChange = (e) => {
    const discount = parseFloat(limitAmount(e.target.value, FormData.totalpaybleamount)) || 0;
    const newPayableAmount = FormData.totalpaybleamount - discount;
    setFormData({ ...FormData, discount, payingamount: newPayableAmount });
  };

  const handleClickcHANGE = () => {
    setSubmitted(true);

    // Validate required fields
    if (!FormData.package ||
        !FormData.packagevalue ||
        !FormData.totalpaybleamount ||
        !FormData.modeofpayment ||
        !FormData.payingamount ||
        !FormData.trainer ||
        !FormData.activationdate ||
        !FormData.dateofpayment ||
        !FormData.ptSession ||
        !FormData.startTime ||
        !FormData.endTime) {
      handleSnackbarOpen("Please fill all required fields.", "error");
      return;
    }

    if (ptTrainerSlotInfo) {
      const sessionOk =
        (FormData.ptSession === "morning" && hasTrainerMorningSlot(ptTrainerSlotInfo)) ||
        (FormData.ptSession === "evening" && hasTrainerEveningSlot(ptTrainerSlotInfo));
      if (!sessionOk) {
        handleSnackbarOpen("Pick a valid session for this trainer.", "error");
        return;
      }
      const st = dayjs(FormData.startTime);
      const et = dayjs(FormData.endTime);
      if (!isPtStartTimeWithinSessionSlot(st, ptTrainerSlotInfo, FormData.ptSession)) {
        handleSnackbarOpen(
          `Start time is outside the selected session. ${trainerSlotAllowedStartSummaryForSession(ptTrainerSlotInfo, FormData.ptSession)}`,
          "error"
        );
        return;
      }
      if (!isPtEndTimeWithinSessionSlot(et, ptTrainerSlotInfo, FormData.ptSession)) {
        handleSnackbarOpen("End time is outside the selected session.", "error");
        return;
      }
    }

    // Format dates and times for API
    const formattedData = {
      ...FormData,
      activationdate: FormData.activationdate ? dayjs(FormData.activationdate).format('YYYY-MM-DD') : null,
      dateofpayment: FormData.dateofpayment ? dayjs(FormData.dateofpayment).format('YYYY-MM-DD') : null,
      startTime: FormData.startTime ? dayjs(FormData.startTime).format('HH:mm') : null,
      endTime: FormData.endTime ? dayjs(FormData.endTime).format('HH:mm') : null,
      slot: FormData.startTime && FormData.endTime ?
        `${dayjs(FormData.startTime).format('HH:mm')}-${dayjs(FormData.endTime).format('HH:mm')}` : '',
    };

    setPendingFormData(formattedData);
    setConfirmChangeOpen(true);
  };

  const doChangePackagePt = async () => {
    if (!pendingFormData || submittingRef.current) return;
    submittingRef.current = true;
    setRenwalLoading(true);
    setConfirmChangeOpen(false);
    try {
      const userData = JSON.parse(localStorage.getItem('userdata'));
      const userToken = userData?.token;
      const res = await TrainerPaymentcHANGE(userToken, member_id, pendingFormData);
      setPendingFormData(null);

      if (res.code === "200" || res.code === 200) {
        handleSnackbarOpen(res.message || "Added successfully", "success");
        setFormData({
          member_id: "",
          package: "",
          packagevalue: "",
          totalpaybleamount: "",
          discount: "",
          payableamount: "",
          modeofpayment: "",
          payingamount: "",
          activationdate: null,
          dateofpayment: null,
          trainer: "",
          slot: "",
          startTime: null,
          endTime: null,
        });
        fetchData();
        onClose();
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("An error occurred. Please try again.", "error");
      setPendingFormData(null);
    } finally {
      setRenwalLoading(false);
      submittingRef.current = false;
    }
  };

  return (
    <>
         <Dialog
        open={open}
        onClose={lockedClose(onClose)}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "800px",
          },
        }}
      >
        <DialogTitle
          sx={{ 
            bgcolor: appColors.evergreen, // Navy blue background
          color: 'white',
            padding: '16px 24px',
            fontSize: '1.25rem',
            fontWeight: 600
          }}
        >
          Change Trainer Package
        </DialogTitle>
        <DialogContent sx={{ minWidth: "800px", mt: 2 }}>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel id="package-label" sx={{ color: appColors.evergreen }}>Choose Trainer Package</InputLabel>
                <Select
                  labelId="package-label"
                  value={FormData.package}
                  onChange={handlepayblevalueChange}
                  label="Choose Trainer Package"
                  error={submitted && !FormData.package}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: appColors.evergreen,
                    }
                  }}
                >
                  {Dropdowndata.map((row) => (
                    <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                  ))}
                </Select>
                {submitted && !FormData.package && (
                  <FormHelperText error>Package is required</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <TextField
                label="Package Value"
                fullWidth
                placeholder="Enter Package Value"
                inputProps={{ readOnly: true }}
                value={FormData.packagevalue}
                error={submitted && !FormData.packagevalue}
                helperText={submitted && !FormData.packagevalue && "Package Value is required"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: appColors.evergreen,
                  }
                }}
              />
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <TextField
                label="Payable Amount"
                type="number"
                fullWidth
                placeholder="Enter Payable amount"
                value={FormData.totalpaybleamount}
                onChange={handleTotalPayableAmountChange}
                helperText={generateHelperText()}
                error={FormData.totalpaybleamount > packageamount}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: appColors.evergreen,
                  }
                }}
              />
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <TextField
                label="Discount"
                fullWidth
                type="number"
                placeholder="Enter Discount"
                value={FormData.discount}
                onChange={handleDiscountChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: appColors.evergreen,
                  }
                }}
              />
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <TextField
                label="Paying Amount"
                fullWidth
                value={FormData.payingamount}
                error={submitted && !FormData.payingamount}
                helperText={submitted && !FormData.payingamount && "Paying Amount is required"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: appColors.evergreen,
                  }
                }}
              />
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth error={submitted && !FormData.modeofpayment}>
                <InputLabel sx={{ color: appColors.evergreen }}>Mode of Payment</InputLabel>
                <Select
                  value={FormData.modeofpayment}
                  onChange={(e) => setFormData({ ...FormData, modeofpayment: e.target.value })}
                  label="Mode of Payment"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: appColors.evergreen,
                    }
                  }}
                >
                  <MenuItem value="paytm">Paytm</MenuItem>
                  <MenuItem value="googlepay">Google Pay</MenuItem>
                  <MenuItem value="phonepe">PhonePe</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="card">Card</MenuItem>
                </Select>
                {submitted && !FormData.modeofpayment && (
                  <FormHelperText>This field is required</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Payment"
                  value={FormData.dateofpayment}
                  onChange={(date) => setFormData({ ...FormData, dateofpayment: date })}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: submitted && !FormData.dateofpayment,
                      helperText: submitted && !FormData.dateofpayment && "Date of Payment is required"
                    }
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Activation Date"
                  value={FormData.activationdate}
                  onChange={(date) => setFormData({ ...FormData, activationdate: date })}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: submitted && !FormData.activationdate,
                      helperText: submitted && !FormData.activationdate && "Activation Date is required"
                    }
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: FormData.end_date ? appColors.evergreen : 'text.secondary' }}>
                {FormData.end_date
                  ? `Expire: ${dayjs(FormData.end_date).format("DD/MM/YYYY")}`
                  : 'Select a package to see expiry'}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel sx={{ color: appColors.evergreen }}>Choose Trainer</InputLabel>
                <Select
                  value={FormData.trainer}
                  onChange={(e) => setFormData({ ...FormData, trainer: e.target.value, ptSession: "", startTime: null, endTime: null })}
                  label="Choose Trainer"
                  error={submitted && !FormData.trainer}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: appColors.evergreen },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: appColors.evergreen },
                  }}
                >
                  <MenuItem value="">
                    <em>Select Trainer</em>
                  </MenuItem>
                  {Dropdowndatatrainer.map((row) => (
                    <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                  ))}
                </Select>
                {submitted && !FormData.trainer && (
                  <FormHelperText error>Trainer is required</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Morning / Evening session */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <FormControl
                fullWidth
                disabled={
                  !FormData.trainer ||
                  ptTrainerSlotLoading ||
                  !(ptTrainerSlotInfo && (hasTrainerMorningSlot(ptTrainerSlotInfo) || hasTrainerEveningSlot(ptTrainerSlotInfo)))
                }
                error={
                  submitted && !!FormData.trainer && !FormData.ptSession &&
                  !!ptTrainerSlotInfo &&
                  (hasTrainerMorningSlot(ptTrainerSlotInfo) || hasTrainerEveningSlot(ptTrainerSlotInfo)) &&
                  !ptTrainerSlotLoading
                }
              >
                <InputLabel>Morning or Evening</InputLabel>
                <Select
                  label="Morning or Evening"
                  value={FormData.ptSession}
                  onChange={(e) => setFormData({ ...FormData, ptSession: e.target.value, startTime: null, endTime: null })}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: appColors.evergreen },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: appColors.evergreen },
                  }}
                >
                  <MenuItem value=""><em>Select session</em></MenuItem>
                  {hasTrainerMorningSlot(ptTrainerSlotInfo) && <MenuItem value="morning">Morning</MenuItem>}
                  {hasTrainerEveningSlot(ptTrainerSlotInfo) && <MenuItem value="evening">Evening</MenuItem>}
                </Select>
                {FormData.trainer && ptTrainerSlotLoading && (
                  <FormHelperText>Loading schedule…</FormHelperText>
                )}
                {submitted && FormData.trainer && !FormData.ptSession && ptTrainerSlotInfo &&
                  (hasTrainerMorningSlot(ptTrainerSlotInfo) || hasTrainerEveningSlot(ptTrainerSlotInfo)) &&
                  !ptTrainerSlotLoading && (
                  <FormHelperText error>Required — pick morning or evening</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Start Time — constrained by session */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Start Time"
                  disabled={!ptTimeBounds || ptTrainerSlotLoading}
                  minTime={ptTimeBounds?.slotStart}
                  maxTime={ptTimeBounds?.maxStart}
                  value={FormData.startTime ? dayjs(FormData.startTime) : null}
                  onChange={(newValue) => {
                    setFormData((prev) => {
                      const next = { ...prev, startTime: newValue };
                      if (newValue && prev.endTime) {
                        const st = dayjs(newValue);
                        const et = dayjs(prev.endTime);
                        if (st.isValid() && et.isValid() && !et.isAfter(st)) next.endTime = null;
                      }
                      return next;
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: submitted && !FormData.startTime,
                      helperText: (() => {
                        if (submitted && !FormData.startTime) return "Start time is required";
                        if (!FormData.ptSession && FormData.trainer && ptTrainerSlotInfo) return "Choose Morning or Evening first.";
                        if (FormData.ptSession && ptTrainerSlotInfo) return trainerSlotAllowedStartSummaryForSession(ptTrainerSlotInfo, FormData.ptSession);
                        return "";
                      })(),
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            {/* End Time — constrained by session */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="End Time"
                  disabled={!ptTimeBounds || ptTrainerSlotLoading || !FormData.startTime}
                  minTime={ptEndPickerMinTime ?? undefined}
                  maxTime={ptTimeBounds?.slotEnd}
                  value={FormData.endTime ? dayjs(FormData.endTime) : null}
                  onChange={(newValue) => setFormData({ ...FormData, endTime: newValue })}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: submitted && !FormData.endTime,
                      helperText: submitted && !FormData.endTime ? "End time is required" : "",
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button 
            variant="outlined"
            onClick={onClose}
            startIcon={<CancelIcon />}
            sx={{ 
              color: appColors.evergreen,
              borderColor: appColors.evergreen,
              '&:hover': {
                borderColor: appColors.pine,
                bgcolor: 'rgba(31, 122, 84, 0.04)'
              },
              textTransform: 'none',
              fontWeight: 600
            }}  
          >
            Cancel
          </Button>
          <PayButton
            variant="contained"
            onClick={handleClickcHANGE}
            startIcon={<CheckCircleIcon />}
            loading={renwalloading}
            sx={{ 
              bgcolor: appColors.evergreen,
              '&:hover': { bgcolor: appColors.pine },
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 4px 6px rgba(31, 122, 84, 0.12)',
              '&:hover': {
                bgcolor: appColors.pine,
                boxShadow: '0 6px 8px rgba(31, 122, 84, 0.2)',
              }
            }} 
          >
             Payment
          </PayButton>
        </DialogActions>
      </Dialog>

      {/* Are you sure? - Change PT Package */}
      <Dialog open={confirmChangeOpen} onClose={lockedClose(() => { setConfirmChangeOpen(false); setPendingFormData(null); })} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to change the package?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setConfirmChangeOpen(false); setPendingFormData(null); }} color="primary" variant="outlined">Cancel</Button>
          <PayButton onClick={doChangePackagePt} color="primary" variant="contained" startIcon={<CheckCircleIcon />} loading={renwalloading}>Yes, change package</PayButton>
        </DialogActions>
      </Dialog>

<PaymentOverlay open={renwalloading} text="Changing PT package" />
<AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
</>
  );
};

export default ChangePackagePt;